const LOAD_DETAIL_CITIES           = 'LOAD_DETAIL_CITIES'
const LOAD_DETAIL_CITIES_SUCCESS   = 'LOAD_DETAIL_CITIES_SUCCESS'
const LOAD_DETAIL_CITIES_FAILED    = 'LOAD_DETAIL_CITIES_FAILED'
const UNMOUNT_DETAIL_CITIES        = 'UNMOUNT_DETAIL_CITIES'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const citiesDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_CITIES:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_CITIES_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_CITIES_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_CITIES:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default citiesDetailReducer;